import { useCallback } from 'react';

import { logger } from '@zep/core-logger';

import { type QuizSetDetailsRes } from '@/api/gen/_model/quizSetDetailsRes';
import { usePremiumAccess } from '@/shared/plan';

interface UseUpgradePlanHandlerParams {
  quizData: QuizSetDetailsRes;
}

/**
 * useUpgradePlanHandler - 잠긴 퀴즈의 「플랜 업그레이드」 핸들러
 *
 * @description
 * 요금제 페이지로 곧장 보내지 않고 **기능 페이월**을 연다.
 *
 * 이 CTA 는 "이 퀴즈가 막혔다"는 구체적인 사유를 알고 눌리는 자리다. 그런 진입에서
 * 결제부터 권하면, 쓸 수 있는 이용권을 가진 사용자에게 돈을 내라고 하는 상황이 된다
 * (예: 2주 PRO 이용권 보유자가 BASIC 템플릿으로 잠긴 퀴즈를 열었을 때).
 * 휴대폰 인증 무료 체험 대상자도 같은 이유로 안내를 놓친다.
 *
 * 요구 등급은 서버가 준 `requiredPlanType` 을 그대로 쓴다. 잠금 판정(`isLocked`)이
 * 같은 응답에서 오므로, 여기서 등급을 다시 추정하면 서버 판정과 어긋날 수 있다.
 */
export const useUpgradePlanHandler = ({
  quizData,
}: UseUpgradePlanHandlerParams) => {
  const { openFeaturePaywall } = usePremiumAccess();

  return useCallback(() => {
    logger.track('plan_upgrade_click', {
      location: 'detail_locked_quiz',
    });

    const requiredPlan =
      quizData.requiredPlanType === 'BASIC' ? 'BASIC' : 'PRO';

    void openFeaturePaywall({
      requiredPlan,
      from: 'detail_locked_quiz',
    });
  }, [openFeaturePaywall, quizData.requiredPlanType]);
};
